import React from 'react';
import { IconMaximize } from '@tabler/icons-react';

export default function ActiveSpeakerTile({ isDisabled = false }) {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div
        className={`h-full w-full ${
          isDisabled ? 'bg-slate-100 text-slate-300' : 'bg-slate-200 text-slate-500 hover:bg-slate-100'
        } flex items-center justify-center rounded`}
      >
        <IconMaximize size={32} stroke={1.5} />
      </div>
    </div>
  );
}
